// O que a linha da EAP diz sobre o próprio cronograma (change 00): a marca "sem cronograma"
// (D5) e a regra que ela herda de um nível acima (D10). Puro, para a linha da árvore e a da
// lista da busca lerem o mesmo texto.
import { ruleKeys } from "../engine";
import { reais } from "../monthEdit";

const NODE_PREFIX = "node:";

/**
 * A marca do item: o `ampliSchedule` da árvore (`{ status, unscheduledCents,
 * unscheduledServices }`) ou, na lista da busca, o serviço com `governance: "unscheduled"`.
 * `null` sem orçamento sem cronograma.
 */
export const scheduleMarkOf = (item) => {
  const mark = item?.ampliSchedule;
  if (mark && Number.isFinite(mark.unscheduledCents) && mark.unscheduledCents > 0) {
    return {
      status: mark.status === "missing" ? "missing" : "partial",
      unscheduledCents: mark.unscheduledCents,
      unscheduledServices: Number.isSafeInteger(mark.unscheduledServices) ? mark.unscheduledServices : 1,
    };
  }
  if (item?.governance === "unscheduled" && item?.unscheduledCents > 0) {
    return { status: "missing", unscheduledCents: item.unscheduledCents, unscheduledServices: 1 };
  }
  return null;
};

/** "Sem cronograma" ou "10 serviços sem cronograma · R$ 531.732,88". */
export const scheduleMarkText = (mark) => {
  if (!mark) return null;
  if (mark.status === "missing") return "Sem cronograma";
  const count = mark.unscheduledServices;
  return `${count.toLocaleString("pt-BR")} ${count === 1 ? "serviço" : "serviços"} sem cronograma · ${reais(mark.unscheduledCents)}`;
};

/** O que corrigir na ferramenta de planejamento, conforme a origem da obra. */
export const planningToolText = (originId) => (originId === "prevision"
  ? "No Prevision, vincule o item a uma atividade do cronograma. A curva se atualiza no próximo sync."
  : "No ERP, distribua o item no físico-financeiro (no MEGA, no previsto mensal). A curva se atualiza no próximo sync.");

const isActive = (rule) => rule && rule.active !== false;
const codeOf = (rule) => String(rule?.target?.key ?? "").slice(NODE_PREFIX.length);

/**
 * A regra de EAP do ancestral mais próximo com regra ativa — a mesma resolução do motor
 * (`nodeKeysFor`: o código é hierárquico, então um ancestral é um prefixo dele).
 */
export const inheritedRuleOf = (wbsCodeId, rulesByNodeKey) => {
  const code = String(wbsCodeId ?? "");
  if (!code) return null;
  let nearest = null;
  for (const [key, rule] of Object.entries(rulesByNodeKey ?? {})) {
    if (!key.startsWith(NODE_PREFIX) || !isActive(rule)) continue;
    const ancestor = key.slice(NODE_PREFIX.length);
    if (ancestor.length >= code.length || !code.startsWith(ancestor)) continue;
    if (!nearest || ancestor.length > codeOf(nearest).length) nearest = rule;
  }
  return nearest;
};

/** Quantos itens abaixo do nó têm regra de EAP própria ("N itens com cronograma próprio"). */
export const ownSchedulesBelow = (wbsCodeId, rulesByNodeKey) => {
  const code = String(wbsCodeId ?? "");
  if (!code) return 0;
  const own = ruleKeys.node(code);
  return Object.entries(rulesByNodeKey ?? {}).filter(([key, rule]) => (
    key !== own && isActive(rule) && key.startsWith(own)
  )).length;
};

export const ownSchedulesText = (count) => (count > 0
  ? `${count.toLocaleString("pt-BR")} ${count === 1 ? "item com cronograma próprio" : "itens com cronograma próprio"}`
  : null);
